import { transport } from 'config/transport';

export function callApiUpdateDanhMucThu(congDoanId, id, body) {
    return transport.put(`/mamnon/${congDoanId}/thuhocsinh/danhmucthu/${id}`, body);
}
